import { FileType } from '../../types'

export const resolveAllowedTypesString = (fileTypes: FileType[], separator: ', ' | ' ' = ' '): string => {
  return fileTypes.map((type) => '.' + type).join(separator)
}
